export default {
  event(category, action, label, value = 0) {
    if (typeof window.dataLayer === 'undefined') {
      return;
    }

    window.dataLayer.push({
      event: 'general_event',
      event_category: category,
      event_action: action,
      event_label: label,
      value,
    });
  },
};
